import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";

const CityContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const readStoredCity = () => {
  try {
    return JSON.parse(localStorage.getItem("heylpmate_city"));
  } catch {
    return null;
  }
};

export function CityProvider({ children }) {
  const [cities, setCities] = useState([]);
  const [city, setCity] = useState(readStoredCity);
  const [pickerOpen, setPickerOpen] = useState(false);

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/cities`).then((r) => {
      if (cancelled) return;
      setCities(r.data.cities);
      if (!readStoredCity() && !sessionStorage.getItem("hm_city_dismissed")) setPickerOpen(true);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const chooseCity = useCallback((c) => {
    setCity(c);
    localStorage.setItem("heylpmate_city", JSON.stringify(c));
    setPickerOpen(false);
  }, []);

  const value = useMemo(
    () => ({ cities, city, chooseCity, pickerOpen, setPickerOpen }),
    [cities, city, chooseCity, pickerOpen]
  );

  return <CityContext.Provider value={value}>{children}</CityContext.Provider>;
}

export const useCity = () => useContext(CityContext);
